// import { combineReducers } from 'redux';
import produce from 'immer';
import { ActionTypes } from '../actions/actionTypes';

export interface IContentReducer {
  content?: any;
}

const initialState: IContentReducer = {
  content: undefined,
};

export default produce((draft: IContentReducer, action: any) => {
  switch (action.type) {
    case ActionTypes.fetchAllContentResolved:
      draft.content = action.content;
      return;
  }
}, initialState);

/*const rootReducer = combineReducers({
  reducer,
});

export default rootReducer; */



// WEBPACK FOOTER //
// ./src/reducers/index.ts